module.exports = __webpack_public_path__ + "static/media/Phil&Ronan_About_Page.176f2dcb.png";